import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {center} from '../../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface CellInternalIconProps {
  isSelected?: boolean;
  className?: string;
}

/*
 * Style.
 */

interface CellInternalIconStyleProps {
  $isSelected?: boolean;
}
const StyledIconDiv = styled.div<CellInternalIconStyleProps>`
  grid-area: middle-left;
  height: 100%;
  ${center()};

  color: ${(p) => (p.$isSelected ? p.theme.invertedIcon : p.theme.greys.shade50)};
`;

/*
 * Component.
 */

export const CellInternalIcon: FC<CellInternalIconProps> = (props) => (
  <StyledIconDiv $isSelected={props.isSelected} className={props.className}>
    <Icon name="discussionFilledSmall" />
  </StyledIconDiv>
);
